import { gql } from '@apollo/client';

export const APPLICATION_LOGO_UPLOADED = gql`
  subscription applicationLogoUploaded {
    applicationLogoUploaded {
      isSmall
    }
  }
`;

export const APPLICATION_THEME_SAVED = gql`
  subscription applicationThemeSaved {
    applicationThemeSaved {
      themeName
    }
  }
`;
